import React from "react";

type Props = {
  currentLength: number | undefined;
  maxCharacterLimit: number | undefined;
  extraSmallText?: boolean;
};

export const CharacterCounter: React.FC<Props> = ({
  currentLength,
  maxCharacterLimit,
  extraSmallText,
}) => {
  return (
    <div
      className={`${extraSmallText ? "text-xs" : "text-sm"} ${
        currentLength! >= maxCharacterLimit!
          ? "text-slate-400"
          : "text-slate-200"
      }`}
    >
      <span>{`${currentLength}/${maxCharacterLimit}`}</span>
    </div>
  );
};
